import {
  Box,
  CircularProgress,
  HStack,
  Select as ChakraSelect,
} from "@chakra-ui/react";

const Select = (props) => {
  const { isLoading, label, _label, _container, children, ...xprops } = props;

  return (
    // <ChakraProvider resetCSS>
    <Box className="bitmama--select" {..._container}>
      {label && (
        <HStack alignItems="center" mb="8px">
          {label && (
            <Box
              as="label"
              display="inline-block"
              fontSize=".85em"
              fontWeight="400"
              color="#4E4B66"
              {..._label}
            >
              {label}
            </Box>
          )}
          {isLoading && (
            <CircularProgress size="14px" isIndeterminate color="green.500" />
          )}
        </HStack>
      )}
      <ChakraSelect
        // w="fit-content"
        borderRadius="16px"
        minH="56px"
        bg="#EFF0F7"
        border="1px solid transparent"
        variant="filled"
        _focus={{
          borderColor: "#06C344",
          boxShadow: "0 0 0 3px #06C3448f",
        }}
        {...xprops}
      >
        {children}
      </ChakraSelect>
    </Box>
    // </ChakraProvider>
  );
};

export default Select;
